<div class="w3-row" style="margin-bottom: 1vh;">
  @if (!addCategory && !addResp && !addFile) {
    <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" >
      @if (element.elementos.length ===0) {
        <div (click)="addQuestion()"><!--(click)="agregarPreguntas(true,1,e.id)"-->
          {{'admin.estructura.nuevo3' | translate}}
          <mat-icon class="iconoMen">add_circle_outline</mat-icon>
        </div>
      }
    </div>
    <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;">
      @if (element.elementos.length === 0) {
        <div (click)="addFileInfo()"><!--(click)="agregarPreguntas(true,1,e.id)"-->
          {{'admin.estructura.nuevo5' | translate}}
          <mat-icon class="iconoMen">add_circle_outline</mat-icon>
        </div>
      }
    </div>
  }

</div>
<ng-container >
  @if (element.questions.length !== 0 || newQuestions.length !== 0) {
    <div class="w3-row">
      <div class="w3-row">
        <table class="w3-table" style="width: 90%; margin-left: auto; margin-right: auto;">
          <thead>
            <tr class="w3-table-title">
              <th class="w3-border-right-balance marginIzq stikyColum anchoNumber">{{'admin.estructura.orden' | translate}}</th>
              <th class="w3-border-right-balance marginIzq stikyColum">{{'admin.estructura.pregunta' | translate}}</th>
              <th class="w3-border-right-balance marginIzq stikyColum anchoNumber">{{'admin.estructura.requerida' | translate}}</th>
              <th class="w3-border-right-balance marginIzq stikyColum anchoNumber"></th>
            </tr>
          </thead>
          
          <tbody>
            @for (elem of element.questions; track element.id; let n = $index) {
              <tr class="w3-table-trtd">
                <td class="borderAllLow marginIzq anchoNumber">
                  <input id="{{'orden'+elem.id}}" matInput type="number" class="inputPon w3-center" value="{{elem.order}}" (change)="editQuestionsId(elem.id)">
                </td>
                <td class="borderAllLow marginIzq">
                  <input id="{{'pregunta'+elem.id}}" matInput type="text" class="inputPon w3-center" value="{{elem.descripcion}}" (change)="editQuestionsId(elem.id)">
                </td>
                <td class="borderAllLow marginIzq anchoNumber">
                  <input id="{{'requerida'+elem.id}}" type="checkbox" class="inputPon w3-center" [checked]="elem.requerida" (change)="editQuestionsId(elem.id)">
                </td>
                <td class="borderAllLow marginIzq anchoNumber">
                  @if (editAnswers === undefined) {
                    <mat-icon class="iconoMen material-icons-outlined" (click)="deleteQuestion(elem.id)" >delete</mat-icon>
                  }
                  @if (fileData.length===0) {
                    <mat-icon class="iconoMen material-icons-outlined" (click)="openAddAnswers(elem)" >settings</mat-icon>
                  }
                </td>
              </tr>
              @if (editAnswers !== undefined && editAnswers.id === elem.id) {
                <tr class="w3-table-trtd">
                  <td colspan="4" style="padding-top: 2vh; padding-bottom: 2vh;">
                    <table class="w3-table" style="width: 90%; margin-left: auto; margin-right: auto;">
                      <thead>
                        <tr class="w3-table-title">
                          <th class="w3-border-right-balance marginIzq stikyColum anchoNumber"></th>
                          <th class="w3-border-right-balance marginIzq stikyColum">{{'admin.estructura.respuestaAgr' | translate}}</th>
                          <th class="w3-border-right-balance marginIzq stikyColum anchoNumber">{{'admin.estructura.scoreAgr' | translate}}</th>
                          <th class="w3-border-right-balance marginIzq stikyColum anchoNumber">
                            <div class="w3-row colorBotonDeNuevo" (click)="addAnswer()">
                              <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      @for (answer of editAnswers.respuestas; track answer.id; let n = $index) {
                          <tr class="w3-table-trtd" >
                            <td class="borderAllLow marginIzq anchoNumber">P-{{n+1}}</td>
                            <td class="borderAllLow marginIzq">
                              <input id="{{'respuesta'+answer.id}}" matInput type="text" class="inputPon w3-center" value="{{answer.respuesta}}" (change)="editAnswerId(answer.id); valueMax(answer.id,'')">
                            </td>
                            <td class="borderAllLow marginIzq anchoNumber">
                              <input id="{{'peso'+answer.id}}" matInput type="number" class="inputPon w3-center" value="{{answer.score}}" 
                                min="0" max="10"  (change)="editAnswerId(answer.id); valueMax(answer.id,'')">
                            </td>
                            <td class="borderAllLow marginIzq anchoNumber">
                              <mat-icon class="iconoMen material-icons-outlined" (click)="deleteAnswer(answer.id)">delete</mat-icon>
                            </td>
                          </tr>
                      }
                      @for (newAnswer of newAnswers; track newAnswer.id; let i = $index) {
                          <tr class="w3-table-trtd" >
                            <td class="borderAllLow marginIzq">N-{{i+1}}</td>
                            <td class="borderAllLow marginIzq">
                              <input id="{{'respuestaN'+i}}" matInput type="text" class="inputPon w3-center" value="{{newAnswer.respuesta}}" (change)="valueMax(i,'N')">
                            </td>
                            <td class="borderAllLow marginIzq">
                              <input id="{{'pesoN'+i}}" matInput type="number" class="inputPon w3-center" value="{{newAnswer.score}}" (change)="valueMax(i,'N')"
                                min="0" max="10" >
                            </td>
                            <td class="borderAllLow marginIzq">
                              <mat-icon class="iconoMen material-icons-outlined" (click)="deleteNewAnswer(i)">delete</mat-icon>
                            </td>
                          </tr>
                      }
                    </table>
                    @if (addResp) {
                      <ng-container>
                        <div class="botonesModales" [ngClass]="canSaveAnswer()">
                          <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="saveAnswers()">{{'acciones.guard' | translate}}</button>
                        </div>
                        <div class="botonesModales">
                          <button mat-flat-button color="success2" style="height: 3vh; width: 100%;" (click)="openAddAnswers(elem)">{{'acciones.cancel' | translate}}</button>
                        </div>
                      </ng-container>
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
          @for (elem of newQuestions; track elem.id; let i = $index) {
            <tbody>
              <tr class="w3-table-trtd" >
                <td class="borderAllLow marginIzq anchoNumber">
                  <input id="{{'ordenN'+i}}" matInput type="number" class="inputPon w3-center" value="{{elem.order}}">
                </td>
                <td class="borderAllLow marginIzq">
                  <input id="{{'preguntaN'+i}}" matInput type="text" class="inputPon w3-center" value="{{elem.descripcion}}">
                </td>
                <td class="borderAllLow marginIzq anchoNumber">
                  <input id="{{'requeridaN'+i}}" type="checkbox" class="inputPon w3-center" [checked]="elem.requerida">
                </td>
                <td class="borderAllLow marginIzq anchoNumber">
                  <mat-icon class="iconoMen material-icons-outlined" (click)="deleteNewQuestion(i)">delete</mat-icon>
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      @if (!addResp) {
        <div class="w3-row" style="margin-top: 2%;">
          <div class="botonesModales" [ngClass]="canSaveQuestion()">
            <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="saveQuestions()">{{'acciones.guard' | translate}}</button>
          </div>
        </div>
      }

    </div>
  }
  <div class="w3-row" style="margin-top: 2%;">
    @if(fileData.length !== 0){
      <div class="w3-row">
        <table class="w3-table" style="width: 90%; margin-left: auto; margin-right: auto;">
          <thead>
            <tr class="w3-table-title">
              <th class="w3-border-right-balance marginIzq stikyColum anchoNumber">{{'admin.estructura.orden' | translate}}</th>
              <th class="w3-border-right-balance marginIzq stikyColum">{{'admin.estructura.pregunta' | translate}}</th>
              <th class="w3-border-right-balance marginIzq stikyColum">{{'admin.estructura.respuestas' | translate}}</th>
              <th class="w3-border-right-balance marginIzq stikyColum anchoNumber">{{'admin.estructura.requerida' | translate}}</th>
              <th class="w3-border-right-balance marginIzq stikyColum anchoNumber"></th>
            </tr>
          </thead>
          <tbody>
            @for (elem of fileData; track elem.id; let i = $index) {
              <tr class="w3-table-trtd">
                <td class="borderAllLow marginIzq anchoNumber">
                  <input id="{{'ordenF'+i}}" matInput type="number" class="inputPon w3-center" value="{{elem.order}}">
                </td>
                <td class="borderAllLow marginIzq">
                  <input id="{{'preguntaF'+i}}" matInput type="text" class="inputPon w3-center" value="{{elem.descripcion}}">
                </td>
                <td class="borderAllLow marginIzq">
                  <table class="w3-table">
                    @for (res of elem.respuestas; track res.id; let j = $index) {
                      <tr>
                        <td class="borderAllLow marginIzq">
                          <input id="{{'respuestaF'+i+j}}" matInput type="text" class="inputPon w3-center" value="{{res.respuesta}}" (change)="valueMaxFile(i,j)">
                        </td>
                        <td class="borderAllLow marginIzq anchoNumber">
                          <input id="{{'pesoF'+i+j}}" matInput type="number" class="inputPon w3-center" value="{{res.score}}" 
                            min="0" max="10"(change)="valueMaxFile(i,j)">
                        </td>
                        <td class="borderAllLow marginIzq">
                          <mat-icon class="iconoMen material-icons-outlined" (click)="deleteAnswerFile(i,j)">delete</mat-icon>
                        </td>
                      </tr>
                    }
                  </table>
                </td>
                <td class="borderAllLow marginIzq anchoNumber">
                  <input id="{{'requeridaF'+i}}" type="checkbox" class="inputPon w3-center" [checked]="elem.requerida">
                </td>
                <td class="borderAllLow marginIzq anchoNumber">
                  <mat-icon class="iconoMen material-icons-outlined" (click)="deleteQuestionFile(i)">delete</mat-icon>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="w3-row" style="margin-top: 2%;">
        <div class="botonesModales" [ngClass]="canSaveQuestion()">
          <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="saveQuestionsFile()">{{'acciones.guard' | translate}}</button>
        </div>
        <div class="botonesModales">
          <button mat-flat-button color="success2" style="height: 3vh; width: 100%;" (click)="cancelAddFile()">{{'acciones.cancel' | translate}}</button>
        </div>
      </div>
    }
  </div>
</ng-container>